
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import PlatformMarkerJungleLogMid from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogMid";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerBarrel";
import MoverData from "../../../components/platformer/MoverData";
import PlatformMarkerCabin from "../../editor/platform-markers/shipwreck/PlatformMarkerCabin";
import PositionMarker from "../../editor/PositionMarker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import SmashableMarkerCrate from "../../editor/entity-markers/SmashableMarkerCrate";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerLogKnot from "../../editor/platform-markers/shipwreck/PlatformMarkerLogKnot";
import PlatformMarkerSubmergedBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel";
import CheckpointMarker from "../../editor/CheckpointMarker";
import PlatformMarkerLog from "../../editor/platform-markers/shipwreck/PlatformMarkerLog";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunkHard2 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 384);

    // platformMarkerLogMid
    const platformMarkerLogMid = new PlatformMarkerJungleLogMid(scene, 454, 1);
    this.add(platformMarkerLogMid);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 179, 267);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 4950, 267);
    this.add(editor_bounds_right);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, 601, 139);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, 287, 139);
    this.add(pole_long_float_png);

    // platformLog_1
    const platformLog_1 = new PlatformMarkerBarrel(scene, 1003, -131);
    this.add(platformLog_1);

    // platformCabin
    const platformCabin = new PlatformMarkerCabin(scene, 1090, 215);
    this.add(platformCabin);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 1003, -125);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 1136, -250);
    this.add(positionMarker_1);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 2058, 113);
    this.add(gemMarker);

    // crateMarker
    const crateMarker = new SmashableMarkerCrate(scene, 2899, -590);
    this.add(crateMarker);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 1107, 76);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 4242, -55);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 4540, -58);
    this.add(gemMarker_8);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 546, -66);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 424, -64);
    this.add(gemMarker_14);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 1566, 166);
    this.add(megaGemMarker_1);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 3008, -507);
    this.add(megaGemMarker_2);

    // pole_long_float_png_10
    const pole_long_float_png_10 = new DecorationFloatingPoleLong(scene, 4582, 139);
    this.add(pole_long_float_png_10);

    // pole_long_float_png_11
    const pole_long_float_png_11 = new DecorationFloatingPoleLong(scene, 4185, 139);
    this.add(pole_long_float_png_11);

    // platformMarkerLogLong_3
    const platformMarkerLogLong_3 = new PlatformMarkerLogKnot(scene, 4386, 9);
    this.add(platformMarkerLogLong_3);

    // platformMarkerSubmergedBarrel
    const platformMarkerSubmergedBarrel = new PlatformMarkerSubmergedBarrel(scene, 1556, 247);
    this.add(platformMarkerSubmergedBarrel);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 307, -36);
    this.add(checkpointMarker);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 4243, -34);
    this.add(checkpointMarker_2);

    // platformLog
    const platformLog = new PlatformMarkerLog(scene, 2894, -456);
    this.add(platformLog);

    // crateMarker_1
    const crateMarker_1 = new SmashableMarkerCrate(scene, 1899, -504);
    this.add(crateMarker_1);

    // megaGemMarker_3
    const megaGemMarker_3 = new MegaGemMarker(scene, 2019, -421);
    this.add(megaGemMarker_3);

    // platformLog_5
    const platformLog_5 = new PlatformMarkerLog(scene, 1905, -370);
    this.add(platformLog_5);

    // platformBarrel_3
    const platformBarrel_3 = new PlatformMarkerBarrel(scene, 2405, -420);
    this.add(platformBarrel_3);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2405, -583);
    this.add(gemMarker_2);

    // crateMarker_2
    const crateMarker_2 = new SmashableMarkerCrate(scene, 3807, -427);
    this.add(crateMarker_2);

    // megaGemMarker_4
    const megaGemMarker_4 = new MegaGemMarker(scene, 3937, -344);
    this.add(megaGemMarker_4);

    // platformLog_2
    const platformLog_2 = new PlatformMarkerLog(scene, 3823, -293);
    this.add(platformLog_2);

    // platformBarrel
    const platformBarrel = new PlatformMarkerBarrel(scene, 3371, -426);
    this.add(platformBarrel);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 3371, -589);
    this.add(gemMarker_3);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerBarrel(scene, 3227, 117);
    this.add(platformLog_3);

    // positionMarker_2
    const positionMarker_2 = new PositionMarker(scene, 3227, 123);
    this.add(positionMarker_2);

    // positionMarker_3
    const positionMarker_3 = new PositionMarker(scene, 3360, 123);
    this.add(positionMarker_3);

    // platformLog_4
    const platformLog_4 = new PlatformMarkerLog(scene, 1995, 188);
    this.add(platformLog_4);

    // positionMarker_4
    const positionMarker_4 = new PositionMarker(scene, 1995, 188);
    this.add(positionMarker_4);

    // positionMarker_5
    const positionMarker_5 = new PositionMarker(scene, 2128, 188);
    this.add(positionMarker_5);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 3289, -28);
    this.add(gemMarker_4);

    // platformMarkerSubmergedBarrel_1
    const platformMarkerSubmergedBarrel_1 = new PlatformMarkerSubmergedBarrel(scene, 2483, 258);
    this.add(platformMarkerSubmergedBarrel_1);

    // platformMarkerSubmergedBarrel_2
    const platformMarkerSubmergedBarrel_2 = new PlatformMarkerSubmergedBarrel(scene, 2884, 250);
    this.add(platformMarkerSubmergedBarrel_2);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 2500, 144);
    this.add(gemMarker_5);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 2904, 122);
    this.add(gemMarker_9);

    // platformBarrel_1
    const platformBarrel_1 = new PlatformMarkerBarrel(scene, 1449, -282);
    this.add(platformBarrel_1);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 1449, -445);
    this.add(gemMarker_10);

    // platformMarkerSubmergedBarrel_3
    const platformMarkerSubmergedBarrel_3 = new PlatformMarkerSubmergedBarrel(scene, 3695, 229);
    this.add(platformMarkerSubmergedBarrel_3);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 3715, 101);
    this.add(gemMarker_1);

    // platformLog_6
    const platformLog_6 = new PlatformMarkerLog(scene, 1907, -647);
    this.add(platformLog_6);

    // platformLog_7
    const platformLog_7 = new PlatformMarkerLog(scene, 2897, -739);
    this.add(platformLog_7);

    // platformLog_8
    const platformLog_8 = new PlatformMarkerLog(scene, 3822, -572);
    this.add(platformLog_8);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // platformLog_1 (components)
    const platformLog_1MoverData = new MoverData(platformLog_1);
    platformLog_1MoverData.startMarker = positionMarker;
    platformLog_1MoverData.endMarker = positionMarker_1;
    platformLog_1MoverData.startWait = 800;

    // crateMarker (components)
    const crateMarkerSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker);
    crateMarkerSimpleBreakableBlocker.allowedCharacter = "panda";

    // crateMarker_1 (components)
    const crateMarker_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_1);
    crateMarker_1SimpleBreakableBlocker.allowedCharacter = "grizz";

    // crateMarker_2 (components)
    const crateMarker_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_2);
    crateMarker_2SimpleBreakableBlocker.allowedCharacter = "ice";

    // platformLog_3 (components)
    const platformLog_3MoverData = new MoverData(platformLog_3);
    platformLog_3MoverData.startMarker = positionMarker_2;
    platformLog_3MoverData.endMarker = positionMarker_3;
    platformLog_3MoverData.startWait = 800;

    // platformLog_4 (components)
    const platformLog_4MoverData = new MoverData(platformLog_4);
    platformLog_4MoverData.startMarker = positionMarker_4;
    platformLog_4MoverData.endMarker = positionMarker_5;
    platformLog_4MoverData.startWait = 800;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
